import {
  IonCol,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
  IonRow,
} from '@ionic/react';
import { UIStore } from "../store/store";
import { setlogin } from "../store/actions";
import { useLocation } from 'react-router-dom';





import {  peopleOutline, newspaperOutline, bookOutline, bulbOutline, homeOutline,briefcaseOutline, businessOutline, helpOutline, wifiOutline, analyticsOutline,settingsOutline, hammerOutline, logInOutline, listOutline, personOutline, personCircleOutline } from 'ionicons/icons';
import './Menu.css';
import React from 'react';
import logo from '../pages/images/logo.png';

interface AppPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
}

const appPages: AppPage[] = [
  // {
  //   title: 'Clients',
  //   url: '/Clients',
  //   iosIcon: peopleOutline,
  //   mdIcon: peopleOutline
  // },
  {
    title: 'Tenants',
    url: '/Tenants',
    iosIcon: personOutline,
    mdIcon: personOutline
  },
  {
    title: 'Users',
    url: '/Users',
    iosIcon: personCircleOutline,
    mdIcon: personCircleOutline
  },
  {
    title: 'Lessor Management',
    url: '/Lessor',
    iosIcon: briefcaseOutline,
    mdIcon: briefcaseOutline
  },
  {
    title: 'Property',
    url: '/Property',
    iosIcon: businessOutline,
    mdIcon: businessOutline
  },
  /* {
    title: 'Room',
    url: '/Room',
    iosIcon: homeOutline,
    mdIcon: homeOutline
  }, */
  {
    title: 'Listings',
    url: '/Listings',
    iosIcon: listOutline,
    mdIcon: listOutline
  },
  {
    title: 'Inquiries',
    url: '/Inquiries',
    iosIcon: helpOutline,
    mdIcon: helpOutline
  },
  {
    title: 'Amenities',
    url: '/Amenities',
    iosIcon: wifiOutline,
    mdIcon: wifiOutline
  },
  {
    title: 'Notifications',
    url: '/Notifications',
    iosIcon: bulbOutline,
    mdIcon: bulbOutline
  },
  {
    title: 'Admin Settings',
    url: '/AdminSettings',
    iosIcon: settingsOutline,
    mdIcon: settingsOutline
  },
  {
    title: 'Admin Account',
    url: '/Accounts',
    iosIcon: bookOutline,
    mdIcon: bookOutline
  },
 
  {
    title: 'Equipment',
    url: '/Equipment',
    iosIcon: hammerOutline,
    mdIcon: hammerOutline
  }
];

const labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

const Menu: React.FC = (props:any) => {
  
  const location = useLocation();

  function Logout() {
    setlogin(false);
    // LoginAPI(ApplicationObject.Email,ApplicationObject.Password);
    UIStore.update((s: { isLoggedIn: boolean; }) => {
        s.isLoggedIn = !s.isLoggedIn;
      });
      window.location.href = "/";
}

  return (
    <IonMenu style = {{ width: "18vw"}} contentId="main" type="overlay">
      <IonContent>
        <IonList id="inbox-list">
          <IonListHeader>    <IonRow style={{ marginBottom: "45px" }}>

            <IonCol>
              <div>

              </div>

            </IonCol>

            <IonCol>


              <img src={logo} alt="logo" />

            </IonCol>


            <IonCol>
              <div>

              </div>

            </IonCol>


          </IonRow></IonListHeader>

          {appPages.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false}>
                <IonItem className={location.pathname === appPage.url ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                  <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
                  <IonLabel>{appPage.title}</IonLabel>
                </IonItem>
              </IonMenuToggle>
            );
          })}

            <IonMenuToggle key={99} autoHide={false}>
                <IonItem href="https://console.firebase.google.com/project/bizprop-bc70e/analytics/overview" target="_blank" routerDirection="none" lines="none" detail={false}>

                <IonIcon slot="start" ios={newspaperOutline} md={newspaperOutline} />
           
                  <IonLabel >Firebase Analytics</IonLabel>

                </IonItem>
              </IonMenuToggle>
            <IonMenuToggle key={99} autoHide={false}>
                <IonItem onClick={()=>{ Logout()}}  routerDirection="none" lines="none" detail={false}>

                <IonIcon slot="start" ios={logInOutline} md={logInOutline} />
           
                  <IonLabel >Logout</IonLabel>

                </IonItem>
              </IonMenuToggle>
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
